import { Tab } from '@opengov/component-library/dist';
import { ITabOptionProps } from '@opengov/component-library/dist/Tab/Tab.Option';
import React from 'react';
import { hardNavigate } from '../../../module/routes/routesUtils';

export const REPORTING_TABS_HEIGHT = 48;

type ReportingTabsProps = {
  activeTabId?: ReportingTabId;
  availableTabs: AvailableTab[];
};

export enum ReportingTabId {
  LegacyReportTab = 'legacyReportTab',
  NewReportTab = 'newReportTab',
  EmbedTestingTab = 'embedTestingTab',
  DashboardTab = 'dashboardTab'
}
export type AvailableTab = ITabOptionProps & { id: ReportingTabId };

export function ReportingTabs({ availableTabs, activeTabId = ReportingTabId.NewReportTab }: ReportingTabsProps) {
  const activeTabIndex = availableTabs.findIndex(({ id }) => id === activeTabId);
  return (
    <Tab.Group
      activeTabIndex={activeTabIndex}
      onTabIndexChanged={(index: number) => {
        const nextTab = availableTabs[index];
        if (nextTab.href) {
          hardNavigate(nextTab.href);
        }
      }}
    >
      {availableTabs.map(({ href: _, ...tabProps }) => (
        <Tab.Option key={tabProps.dataTest} {...tabProps} />
      ))}
    </Tab.Group>
  );
}
